import { render, staticRenderFns } from "./SearchPolicyList.vue?vue&type=template&id=2a5f8e26&scoped=true"
import script from "./SearchPolicyList.vue?vue&type=script&lang=js"
export * from "./SearchPolicyList.vue?vue&type=script&lang=js"
import style0 from "./SearchPolicyList.vue?vue&type=style&index=0&id=2a5f8e26&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5f8e26",
  null
  
)

export default component.exports